import React from 'react';

import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

// Team Display
const getTeam = (teams, teamId) => {
    return teams.filter((team) => team.id == teamId)[0];
};

const getSeasonFromGameId = (gameId) => {
    const startOfSeason = gameId.toString().substring(0, 4);
    const endOfSeason = parseInt(startOfSeason, 10) + 1;
    return `${startOfSeason}${endOfSeason}`;
};

const createTeamDisplay = (gameId, teamId, teams, displayName = false) => {
    const team = getTeam(teams, teamId);
    const seasonId = getSeasonFromGameId(gameId);

    return !team ? null : <TeamDisplay team={team} season={seasonId} displayName={displayName} />;
};

export default {
    getTeam,
    getSeasonFromGameId,
    createTeamDisplay,
};
